<style lang="sass">
Table
  text-align: center
.top
  margin: 30px auto
.pages
  margin: 30px auto
</style>
<template>
    <Card>
        <div class="search-div">

            <Select placeholder="请选择审核状态搜索"  clearable class="input-div" v-model="searchObj.status" >
                <Option v-for="(item, index) in searchObjArr.status" :value="item.id" :key="index">{{item.val}}</Option>
            </Select>
            <Select placeholder="请选择提单类型搜索"  clearable class="input-div" v-model="searchObj.type" >
                <Option v-for="(item, index) in searchObjArr.type" :value="item.id" :key="index">{{item.val}}</Option>
            </Select>
            <Input class="input-div" placeholder="请输入订单号搜索" clearable v-model="searchObj.order_sn" ></Input>
            <Input class="input-div" placeholder="请输入资源名搜索" clearable v-model="searchObj.source_name" ></Input>

            <Button type="primary" @click="searchItem">搜索</Button>
        </div>
        <div class="top">
            <Button type="error" @click="todelData" :disabled="buttonList.delDisabled">删除</Button>
        </div>
         <Table :columns="titleName" :data="tableList.tableData" @on-sort-change="sortCustom" ref="selection" @on-selection-change="selectChange" ></Table>
          <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[10,20,30,50]" placement="top" class="pages"/>
        <detail :showModel.sync="detailBox.showModel" :editFormData="detailBox.editFormData" :fn="detailBox.callbackAdFn" ></detail>

        <!-- 删除弹框组件 -->
        <DeleteDialog ref="deleteChild" @ievent = "ievent"></DeleteDialog>
    </Card>
</template>
<script>

import common from '@/common/common.js';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件\
import detail from './detailModel';

    export default {
        name: "agentAdmin",
        components: {
            DeleteDialog,
            detail
        },
        data(){
            return{
                url:this.config.sourceUrl,
                selectChangeData: [],
                loading: true,
                type:1,//弹框打开类型 1添加 2编辑
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                addBox:{//规格弹框组
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                importBox:{//导入员工弹框组
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
                buttonList:{//按钮组
                    addDisabled:false,//添加按钮是否禁用
                    editDisabled:true,//编辑按钮是否禁用
                    delDisabled:true,//删除按钮是否禁用
                },
                page:{//分页排序
                    total:0,//总条数
                    pageSize:20,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                searchObjArr:{
                    status:[
                        {id: 1,val:'待审核'},
                        {id: 2,val:'已通过'},
                        {id: 3,val:'已驳回'},
                    ],
                    type:[
                        {id: 1,val:'广告'},
                        {id: 2,val:'产品与服务'},
                        {id: 3,val:'增值服务'},
                    ]
                },
                searchObj:{
                    order_sn:"",
                    source_name:"",
                    type:"",
                    agent_id:"",
                    status:"",
                },
                detailBox:{//订单
                    showModel:false,//订单弹框开关
                    editFormData:{},
                    callbackAdFn:()=>{}, //订单弹框的回调函数
                },
                titleName: [
                    { //多选框
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '订单号',
                        key: 'order_sn',
                        minWidth:120,
                    },
                    {
                        title: '资源',
                        key: 'source_name',
                        minWidth: 80,
                    },
                    {
                        title: '赠送',
                        key: 'give_id',
                        minWidth: 60,
                        render: (h, params) => {
                            return h('span', params.row.give_id>0?'是':'否')
                        }
                    },
                    {
                        title: '类型',
                        key: 'type',
                        minWidth: 60,
                        render: (h, params) => {
                            let type = {1:'广告', 2:'产品与服务', 3:'增值服务'}
                            return h('span', type[params.row.type])
                        }
                    },
                    {
                        title: '状态',
                        key: 'status',
                        minWidth: 60,
                        render: (h, params) => {
                            let status = {1:'待审核', 2:'已通过', 3:'已驳回'}
                            return h('span', status[params.row.status])
                        }
                    },
                    {
                        title: '添加时间',
                        key: 'created_at',
                        minWidth: 100,
                    },
                    {
                        title: '操作',
                        key: 'id',
                        minWidth: 80,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.viewData(params)
                                        }
                                    }
                                }, '详情')

                            ]);
                        }
                    },
                ],
            }
        },
        created() {
            this.getData();
        },
        methods: {
            todelData() {
                this.$refs.deleteChild.showit();
            },
            // 批量删除
            ievent() {
                let getData = {
                    id: this.tableList.hasSelectData.id,
                }
                this.axios.post(this.config.urlArray.orderDestroy, getData).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.clearbtnStatus();
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    common.msg('error','删除失败')
                })
            },
            searchItem(){
                this.getData()
            },
            getData() {//获取数据
                let getData = {
                    params: {
                        page: this.page.current,
                        pagesize: this.page.pageSize,
                        sortfield: this.page.key,
                        ascDesc: this.page.order
                    }
                }
                 Object.assign(getData.params,this.searchObj)
                this.axios.get(this.config.urlArray.orderShow, getData).then((result) => {
                    common.ajaxMsg(result.data);
                    let resData = result.data.data.list
                    //处理数组
                    this.tableList.tableData = resData
                    this.page.total = result.data.data.paging.total
                    this.loading = false
                }).catch((err) => {
                    common.msg('error','获取失败',()=>{})
                });
            },
            viewData (params) {  //审核
                this.detailBox.showModel = true
                params.row.content = JSON.parse(params.row.content)
                this.detailBox.editFormData = params.row
                this.detailBox.callbackAdFn = () => {//回调处理
                    //重新载入
                    this.getData()
                    this.detailBox.showModel = false;
                }
            },
            sortCustom(data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            selectChange(res) { //控制编辑和删除按钮的可用状态
                this.selectChangeData = res
                if(res.length == 1){
                    this.buttonList.editDisabled = this.buttonList.delDisabled = false
                    this.tableList.hasSelectData = res[0]
                }else{
                    this.buttonList.editDisabled = this.buttonList.delDisabled = true
                    this.tableList.hasSelectData = {}
                }
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                this.getData();
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
            clearbtnStatus() { //删除后清空编辑数据 与按钮状态
                this.buttonList.delDisabled = true
                this.buttonList.editDisabled = true
                this.addBox.editFormData ={}
                this.tableList.hasSelectData = {}
            },
        }
    }
</script>
